import React, { useState, useEffect } from 'react';
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Checkbox,
  // IconButton,
} from '@mui/material';
// import { ExpandMoreIcon } from '../../assets';
import { useStyles } from './listLoading.styles';

export interface ListLoadingProps {
  classes: Record<string, string>;
  className?: string;
  expand?: React.JSX.Element | React.ElementType;
  hasBulkActions?: boolean;
  nbChildren: number;
  nbFakeLines?: number;
  size?: 'small' | 'medium';
}

const times = (nbChildren, fn) =>
  Array.from({ length: nbChildren }, (_, key) => fn(key));

export function ListLoading({
  classes: _classes,
  className,
  // expand,
  hasBulkActions,
  nbChildren,
  nbFakeLines = 5,
  size = 'medium',
}: ListLoadingProps) {
  const [classes] = useState(_classes);
  const [oneSecondHasPassed, setOneSecondHasPassed] = useState(false);
  const { classes: otherClasses, cx } = useStyles();

  useEffect(() => {
    const timeOut = setTimeout(() => setOneSecondHasPassed(true), 1000);
    return () => clearTimeout(timeOut);
  }, []);

  return oneSecondHasPassed ? (
    <Table className={cx(classes.table, className)} size={size}>
      <TableHead>
        <TableRow className={classes.row}>
          {/* {expand && (
            <TableCell padding='none' className={classes.expandHeader} />
          )} */}
          {hasBulkActions && (
            <TableCell padding='checkbox' className={classes.expandIconCell}>
              <Checkbox
                className='select-all'
                color='primary'
                checked={false}
              />
            </TableCell>
          )}
          {times(nbChildren, (key) => (
            <TableCell variant='head' className={classes.headerCell} key={key}>
              <div className={cx(otherClasses.root)}>&nbsp;</div>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {times(nbFakeLines, (key1) => (
          <TableRow key={key1} style={{ opacity: 1 / (key1 + 1) }}>
            {/* {expand && (
              <TableCell padding='none' className={classes.expandIconCell}>
                <IconButton
                  className={classes.expandIcon}
                  component='div'
                  aria-hidden='true'
                >
                  <ExpandMoreIcon />
                </IconButton>
              </TableCell>
            )} */}
            {hasBulkActions && (
              <TableCell padding='checkbox' className={classes.expandIconCell}>
                <Checkbox
                  className='select-all'
                  color='primary'
                  checked={false}
                />
              </TableCell>
            )}
            {times(nbChildren, (key2) => (
              <TableCell className={classes.rowCell} key={key2}>
                <div className={cx(otherClasses.root)}>&nbsp;</div>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  ) : null;
}
